(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/payment/assets/javascripts/api/jupiter/vouchers/dialogs/payment-success.js') >= 0) return;  svs.modules.push('/components/tur/payment/assets/javascripts/api/jupiter/vouchers/dialogs/payment-success.js');
'use strict';

class PaymentSuccess extends svs.tur.payment.dialogs.PaymentSuccess {
  constructor(_ref) {
    let {
      products,
      recipientName,
      contactInfo,
      onConfirm,
      deliveryDate
    } = _ref;
    super({});
    this.products = products;
    this.recipientName = recipientName;
    this.contactInfo = contactInfo;
    this.onConfirm = onConfirm;
    const dateObj = deliveryDate ? new Date(deliveryDate) : new Date();
    const isDateFuture = dateFns.isFuture(dateObj);
    this.deliveryDate = isDateFuture && dateObj;
  }
  getTitle() {
    const {
      deliveryDate,
      products
    } = this;
    const isPlural = products.length > 1 || products[0].count > 1;
    if (deliveryDate) {
      return "".concat(isPlural ? 'Dina lotter är betalade!' : "Din ".concat(this.products[0].name, " \xE4r betalad!"));
    }
    return "".concat(isPlural ? 'Dina lotter är betalade och skickade' : "Din ".concat(this.products[0].name, " \xE4r betalad och skickad"), " till ").concat(this.recipientName, "!");
  }
  getMessage() {
    const {
      deliveryDate,
      products
    } = this;
    const isPlural = products.length > 1 || products[0].count > 1;
    const dateObj = deliveryDate ? new Date(deliveryDate) : new Date();
    const readableDate = dateObj.toLocaleDateString('sv-SE', {
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    });
    const readableTime = dateFns.format(dateObj, 'HH:mm');
    const upperText = deliveryDate ? "".concat(isPlural ? 'Lotterna' : 'Lotten', " kommer skickas till ").concat(this.recipientName, "<span class=\"f-bold nowrap\">\n    ").concat(readableDate, ", kl ").concat(readableTime, "</span><br><br>") : '';
    const lowerText = ["".concat(isPlural ? 'Dina köpta presentlotter' : 'Din köpta presentlott', " som du gett bort hittar du i <a class=\"alert-text-link\"\n     href=\"", "".concat(svs.core.urlMapping.get('myBetsHome'), "/presentlotter"), "\">Mina spel</a>.")];
    const text = upperText + lowerText;
    return [{
      type: svs.components.dialog.message.TEXT,
      text,
      align: svs.components.dialog.message.align.CENTER
    }];
  }
  getActions() {
    return [{
      title: 'ok',
      callback: (e, forms, dialog) => {
        dialog.close();
        if (this.onConfirm) {
          this.onConfirm();
        }
      }
    }];
  }
}
svs.tur.payment.api.jupiter.vouchers.dialogs.PaymentSuccess = PaymentSuccess;

 })(window);